import { useCallback, useState } from "preact/hooks";
import axios from "axios";


export default function useAxios() {

    const initialState = { isLoading: false, data: null, status: NaN, error: null };

    const [currentState, setCurrentState] = useState(initialState);

    const onAxiosResponse = (res) => {
        setCurrentState({ isLoading: false, data: res.data, status: res.status, error: null });
    };
    const onAxiosError = (error) => {
        setCurrentState({ isLoading: false, data: null, status: 400, error: error.message });
    }

    const setAxiosRequest = useCallback((url, config = { method: "GET" }) => {
        setCurrentState({ isLoading: true, data: null });

        const selectedConsumerId = localStorage.getItem('selectedConsumerId');

        const enhancedConfig = { ...config };

        if (selectedConsumerId && selectedConsumerId !== 'null') {
            if (!enhancedConfig.params) {
                enhancedConfig.params = {};
            }
            enhancedConfig.params.consumer_id = selectedConsumerId;

            if (!enhancedConfig.headers) {
                enhancedConfig.headers = {};
            }
            enhancedConfig.headers['x-consumer-id'] = selectedConsumerId;
        }

        return axios(url, enhancedConfig).then(onAxiosResponse).catch(onAxiosError);
    }, []);

    return { ...currentState, fetch: setAxiosRequest };
}